import React from 'react';
import './signature.css';
import NeosperienceSignature from './NeosperienceSignature';

class Signature extends React.Component {
    renderSignatureComponent(qualifier, value, link) {
        if (value !== undefined && value.length > 0) {
            return (
                <span>
                    <strong>{qualifier}</strong>
                    <a className="links" href={link}>
                        {value}
                    </a>
                    <span> | </span>
                </span>
            );
        }
    }

    render() {
        const { user } = this.props;

        return (
            <div className="signature">
                <span className="user"> {`${user.name} ${user.surname}`}</span>
                <span> | </span>
                <span className="user">{user.job}</span>
                <br />
                <span className="info">
                    {this.renderSignatureComponent(
                        'm',
                        user.mobile,
                        `tel:${user.mobile}`
                    )}
                    {this.renderSignatureComponent(
                        'e',
                        user.email,
                        `mailto:${user.email}`
                    )}
                    {this.renderSignatureComponent(
                        'in',
                        user.linkedin,
                        user.linkedin
                    )}
                    {this.renderSignatureComponent(
                        'w',
                        user.website,
                        user.website
                    )}
                </span>
                <br />
                <br />
                <NeosperienceSignature />
            </div>
        );
    }
}

export default Signature;



// WEBPACK FOOTER //
// ./src/Signature.js